import React, { CSSProperties } from "react";

interface InfoCardProps {
  title: string;
  value: string | number;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>> | string;
  className?: string;
  style?: CSSProperties;
}

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  value,
  icon: Icon,
  className = "",
}) => {
  return (
    <div className="flex items-center gap-4">
      {/** Icon */}
      {Icon && (
        <div className="bg-[#F5F5F5] h-10 w-10 rounded-full flex items-center justify-center overflow-hidden">
          {typeof Icon === "string" ? (
            <img src={Icon} alt={title} className="w-5 h-5 object-contain" />
          ) : (
            /** If it's a component like User - from Lucide Icons ... */
            (() => {
              const IconComponent = Icon as React.ElementType;
              return <IconComponent className="w-5 h-5 text-gray-700" />;
            })()
          )}
        </div>
      )}

      {/** Text */}
      <div>
        <p className="text-sm text-black/50 mb-1">{title}</p>
        <p className="text-black text-sm">{value || "N/A"}</p>
      </div>
    </div>
  );
};
